import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import Code from './pages/Code';
import AccountHome from './pages/AccountHome';
import AccountExpense from './pages/AccountExpense';
import AccountCheck from './pages/AccountCheck';
import AccountAdd from './pages/AccountAdd';
import AccountWithdraw from './pages/AccountWithdraw';
import AccountHistory from './pages/AccountHistory';
import AccountSetting from './pages/AccountSetting';
import AccountContact from './pages/AccountContact';
import TradingAccountOpen from './pages/TradingAccountOpen';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminOperations from './pages/AdminOperations';
import AdminUsers from './pages/AdminUsers';
import AdminAccounts from './pages/AdminAccounts';
import AdminBankAccounts from './pages/AdminBankAccounts';
import AdminTradingAccounts from './pages/AdminTradingAccounts';
import AdminDeposits from './pages/AdminDeposits';
import AdminWithdrawals from './pages/AdminWithdrawals';
import AdminStats from './pages/AdminStats';
import AdminProfits from './pages/AdminProfits';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import SupportWidget from './components/SupportWidget';
import './components/Button.css';
import './components/CustomSelect.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/code" element={<Code />} />
          <Route path="/account" element={<AccountHome />} />
          <Route path="/account/expense" element={<AccountExpense />} />
              <Route path="/account/check" element={<AccountCheck />} />
              <Route path="/account/add" element={<AccountAdd />} />
              <Route path="/account/withdraw" element={<AccountWithdraw />} />
              <Route path="/account/history" element={<AccountHistory />} />
              <Route path="/account/setting" element={<AccountSetting />} />
              <Route path="/account/contact" element={<AccountContact />} />
              <Route path="/account/trading-open" element={<TradingAccountOpen />} />
              {/* Админ-панель */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={
                <AdminProtectedRoute>
                  <AdminDashboard />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/operations" element={
                <AdminProtectedRoute>
                  <AdminOperations />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <AdminProtectedRoute>
                  <AdminUsers />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/accounts" element={
                <AdminProtectedRoute>
                  <AdminAccounts />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/bank-accounts" element={
                <AdminProtectedRoute>
                  <AdminBankAccounts />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/trading-accounts" element={
                <AdminProtectedRoute>
                  <AdminTradingAccounts />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/deposits" element={
                <AdminProtectedRoute>
                  <AdminDeposits />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/withdrawals" element={
                <AdminProtectedRoute>
                  <AdminWithdrawals />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/stats" element={
                <AdminProtectedRoute>
                  <AdminStats />
                </AdminProtectedRoute>
              } />
              <Route path="/admin/profits" element={
                <AdminProtectedRoute>
                  <AdminProfits />
                </AdminProtectedRoute>
              } />
        </Routes>
        <SupportWidget />
      </div>
    </Router>
  );
}

export default App;